import { Link } from '@inertiajs/react';
import Layout from '../layouts/layout';
import styles from './error.module.css';

type Props = {
  status: number;
};

export default function Error(_props: Props) {
  const { status } = _props;
  const title = {
    503: '503: Service Unavailable',
    500: '500: Server Error',
    404: '404: Page Not Found',
    403: '403: Forbidden',
  }[status];

  const description = {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[status];

  return (
    <Layout>
      <div className={styles.info}>
        <h2 className={styles.heading}>{title}</h2>
        <p className={styles.text}>
          {description}
          <br />
          <Link href="/" prefetch>
            Return to prefecture list
          </Link>
        </p>
      </div>
    </Layout>
  );
}
